'use client';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';
import { TableOfContentsHeadingProps } from './types';
import { useTableOfContents } from './useTableOfContents';
import { COMPONENT_ID_DESKTOP, COMPONENT_ID_MOBILE } from './utils';

type Props = {
  headingLevel: number;
  headings: TableOfContentsHeadingProps[];
};

export const TOCContainer = ({ headingLevel, headings }: Props) => {
  const { activeId, setActiveId, fireNavigateToSectionPageAction } = useTableOfContents({
    headings,
  });
  return (
    <>
      <Desktop
        distanceToSectionWrapper={2}
        headingLevel={headingLevel}
        headings={headings}
        tocId={COMPONENT_ID_DESKTOP}
        activeId={activeId}
        setActiveId={setActiveId}
        fireNavigateToSectionPageAction={fireNavigateToSectionPageAction}
      />
      <Mobile
        distanceToSectionWrapper={2}
        headingLevel={headingLevel}
        headings={headings}
        activeId={activeId}
        setActiveId={setActiveId}
        fireNavigateToSectionPageAction={fireNavigateToSectionPageAction}
        tocId={COMPONENT_ID_MOBILE}
      />
    </>
  );
};
